"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mediaQuery = exports.sizes = exports.gutters = exports.margins = exports.columns = exports.breakpoints = void 0;

var _styledComponents = /*#__PURE__*/require("styled-components");

var breakpoints = {
  XL: 960,
  // TV
  L: 769,
  // Portal 8 cols
  M: 560,
  // Portal 6 cols
  S: 0 // Mobile

};
exports.breakpoints = breakpoints;
var columns = {
  XL: 12,
  L: 8,
  M: 6,
  S: 4
};
exports.columns = columns;
var margins = {
  XL: 4,
  L: 3.5,
  M: 3.5,
  S: 1
};
exports.margins = margins;
var gutters = {
  XL: 1,
  L: 1,
  M: 1,
  S: 0.5
};
exports.gutters = gutters;
var sizes = /*#__PURE__*/Object.keys(breakpoints);
/**
 * Обертка над css-медиазапросами с заранее определенными брейкпоинтами.
 */

exports.sizes = sizes;

var mediaQuery = function mediaQuery(breakpoint) {
  var deviceScale = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;
  var index = sizes.indexOf(breakpoint);
  var nextBreakpoint = sizes[index - 1];
  var min = breakpoints[breakpoint] > 0 ? breakpoints[breakpoint] * deviceScale : null;
  var max = breakpoints[nextBreakpoint] ? (breakpoints[nextBreakpoint] - 1) * deviceScale : null;

  if (min === null && max !== null) {
    return function (content) {
      return (0, _styledComponents.css)(["@media (max-width:", "px){", "}"], max, content);
    };
  }

  if (min !== null && max !== null) {
    return function (content) {
      return (0, _styledComponents.css)(["@media screen and (min-width:", "px) and (max-width:", "px){", "}"], min, max, content);
    };
  }

  return function (content) {
    return (0, _styledComponents.css)(["@media (min-width:", "px){", "}"], min, content);
  };
};

exports.mediaQuery = mediaQuery;